import queryString from "query-string"
import { removeNullParams } from "@src/utils/common"

type FetchPublicClientOptions = {
  method?: string
  url: string
  body?: string
  queries?: object
  noContentType?: boolean
}

const getLocaleFromCookies = () => {
  if (typeof document === "undefined") return "vi"
  return document.cookie.match(/NEXT_LOCALE=([^;]+)/)?.[1] || "vi"
}

/**
 * Public browser request path. It deliberately avoids getSession() because
 * public catalog endpoints do not need an auth/session round-trip.
 */
export default async function fetchPublicClient({
  method = "GET",
  url,
  body = "",
  queries,
  noContentType
}: FetchPublicClientOptions) {
  const baseUrl = process.env.NEXT_PUBLIC_API_URL
  const requestUrl = queries
    ? queryString.stringifyUrl({
        url,
        query: removeNullParams(queries)
      })
    : url

  const response = await fetch(`${baseUrl}${requestUrl}`, {
    method,
    headers: {
      Accept: "application/json",
      "Accept-Language": getLocaleFromCookies(),
      ...(!noContentType && { "Content-Type": "application/json" })
    },
    body: body || undefined
  })

  if (!response.ok) {
    throw response
  }

  return response.json()
}
